import React from "react";
import CountUp from "react-countup";
import stars from "../../assets/images/stars.svg";

const EventsReviewed = ({ isVisible }) => {
  return (
    <div className="events-review">
      <div className="counter">
        <span className="text-secondary fs-145 font-weight-thin">
          {isVisible && <CountUp end={250000000} duration={3} />}+
        </span>
      </div>
      <span className="fs-24 font-weight-semibold text-black events-scored">
        Events Reviewed and Scored
      </span>
      <div className="events-review-bg">
        <div className="stars">
          <img src={stars} alt="Stars" />
        </div>
      </div>
    </div>
  );
};

export default EventsReviewed;
